module.exports = __webpack_public_path__ + "media/img/Landing_Page/togglebar-303be30a3ad41f9062ae63b2ea808bdb.svg";